import React from "react";
import PropTypes from "prop-types";

import { DialogStepper } from "ui/Dialog";

import InformationContent from "./InformationContent";
import LimitsContent from "./LimitsContent";
import FeaturesContent from "./FeaturesContent";

import ListIcon from "assets/svg/list.svg";
import LimitIcon from "assets/svg/speed.svg";
import FeatureIcon from "assets/svg/features.svg";

import useDialogMutation from "hooks/useDialogMutation";
import useLicenseTemplateSuggests from "hooks/licenseTemplate/useLicenseTemplateSuggests";

import { CREATE_LICENSE_TEMPLATE } from "graphqlQueries/licenseTemplate";
import { READ_LICENSES_NAME } from "graphqlQueries/licenses";
import { createLicenseTemplateMapper } from "graphqlQueries/licenseTemplate.map";

import {
  validateInformation,
  validateLimits,
} from "validators/createLicenseTemplateValidator";

const CreateLicenseTemplateDialog = ({ onClose, ariaLabelledby }) => {
  const {
    initialValues,
    limitFields,
    featureFields,
    loading: preLoading,
  } = useLicenseTemplateSuggests();

  const { handleSubmit, loading } = useDialogMutation(
    CREATE_LICENSE_TEMPLATE,
    onClose,
    {
      dataMapper: createLicenseTemplateMapper,
      refetchQueries: [READ_LICENSES_NAME],
    },
  );

  const steps = [
    {
      title: "Information",
      Icon: ListIcon,
      validationSchema: validateInformation,
      renderContent: InformationContent,
    },
    {
      title: "Limits",
      Icon: LimitIcon,
      validationSchema: validateLimits(limitFields),
      renderContent: () => <LimitsContent limitFields={limitFields} />,
    },
    {
      title: "Features",
      Icon: FeatureIcon,
      renderContent: () => <FeaturesContent featureFields={featureFields} />,
    },
  ];

  return (
    <DialogStepper
      initialValues={initialValues}
      title="New license template"
      className="license-template-dialog"
      contentClassName="license-template-dialog-content"
      onSubmit={handleSubmit}
      onClose={onClose}
      ariaLabelledby={ariaLabelledby}
      steps={steps}
      isLoading={loading}
      preLoading={preLoading}
      preLoadingHeight="122px"
      enableReinitialize
    />
  );
};

CreateLicenseTemplateDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  ariaLabelledby: PropTypes.string,
};

export default CreateLicenseTemplateDialog;
